import './_index.scss';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';

const RouteLeavingGuard = ({ when, navigate, shouldBlockNavigation }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmedNavigation, lastLocation]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <Modal show={modalVisible} onHide={closeModal} bsSize="sm" className="modal-leave">
        <Modal.Body>
          <div className="modal-leave-title">You have unsaved changes</div>
          <div className="modal-leave-description">
            <div>All changes will not be saved.</div>
            <div>Are you sure you want to leave this page?</div>
          </div>
          <div className="modal-leave-actions">
            <Button bsStyle="primary" onClick={handleConfirmNavigationClick}>
              Leave
            </Button>
            <Button onClick={closeModal}>Cancel</Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

RouteLeavingGuard.propTypes = {
  when: PropTypes.bool,
  navigate: PropTypes.func,
  shouldBlockNavigation: PropTypes.func,
};

export default RouteLeavingGuard;
